import { motion } from 'motion/react';

export const WordAnimated = ({ word, allDuration, allDelay = 0 }) => {
  const letters = word?.replaceAll(' ', '\u00A0').split('');

  const idxDelay = (allDuration - 0.2) / letters.length;

  return (
    <>
      {letters &&
        Array.isArray(letters) &&
        letters.map((l, idx, arr) => {
          return (
            <motion.div
              style={{ position: 'relative' }}
              key={l + idx}
              initial={{ opacity: 0, y: '4rem' }}
              animate={{ opacity: 1, y: '0' }}
              transition={{ duration: 0.2, delay: idx * idxDelay + allDelay }}
            >
              {l}
            </motion.div>
          );
        })}
    </>
  );
};
